import { useTranslation } from '@sortlist-frontend/translation/ssr';
import { useRouter } from 'next/router';

import { SearchTopics } from '_components/SearchTopic/SearchTopics';
import { usePublicAppContext } from '_core/context/public-app-context';
import { useDomain } from '_core/repos/public-api/domain.repo';

export const AgencySearchInput = () => {
  const { t } = useTranslation(['common']);
  const { domainInfo, locale } = usePublicAppContext();
  const { data: domain } = useDomain(domainInfo?.getOriginUrl() ?? '');
  const router = useRouter();

  return (
    <SearchTopics
      page="comparator-landing"
      cta="discover"
      element="discover"
      type="service"
      className="shadow-5-secondary-500 rounded-xl flex-50 layout-row layout-align-start-center text-left"
      placeholder={t('common:navbar.menu.whatService')}
      navigationData={{ origin: domainInfo?.getOriginUrl() ?? '', locale, resolvedUrl: router.asPath, domain }}
    />
  );
};
